import { useFetchers } from 'react-router';
import type { OptimisticTags, TagType } from '../type';

const useOptimisticTags = (
    imageId: number,
    tags: TagType[],
): OptimisticTags => {
    const fetchers = useFetchers();

    if (!tags) return { tags };

    const submissionFetcher = fetchers.find(
        (fetcher) =>
            fetcher.state !== 'idle' &&
            fetcher?.formAction?.startsWith('/remix-api/product-tagging/'),
    );

    if (submissionFetcher && submissionFetcher?.formAction) {
        const { formData } = submissionFetcher;
        if (formData) {
            const key = String(formData.get('fetcherKey'));
            const targetImageId = Number(formData.get('libraryImageID'));
            switch (submissionFetcher.formAction) {
                case '/remix-api/product-tagging/delete-library-image-marker': {
                    if (imageId !== targetImageId) return { tags };
                    const tagId = Number(formData.get('tagId'));
                    const newTags = tags.filter((tag) => tag.id !== tagId);
                    return {
                        tags: newTags,
                        fetcherKey: key,
                    };
                }
                case '/remix-api/product-tagging/create-marker': {
                    if (imageId !== targetImageId) return { tags };
                    const optimisticData = String(
                        formData.get('optimisticData'),
                    );
                    const optimisticTag = JSON.parse(optimisticData) as TagType;
                    const newTags: TagType[] = tags.slice();
                    if (!newTags.some((tag) => tag.id === optimisticTag.id)) {
                        newTags.push(optimisticTag);
                    }

                    return {
                        tags: newTags,
                        fetcherKey: key,
                    };
                }
                case '/remix-api/product-tagging/update-library-image-marker': {
                    const rawApproved = formData.get('approved');
                    const id = Number(formData.get('tagId'));
                    const newTags = tags.map((tag) => {
                        if (tag.id === id) {
                            return {
                                ...tag,
                                ...(rawApproved !== null && {
                                    approved: rawApproved === 'true',
                                }),
                            };
                        }
                        return tag;
                    });

                    return {
                        tags: newTags,
                        fetcherKey: key,
                    };
                }
            }
        }
    }

    return { tags };
};

export default useOptimisticTags;
